import { LocaleService } from '@sm360/widget-commons-core-services';
import { forOwn, snakeCase, toUpper } from 'lodash';

class ErrorService {
    getErrors(fieldValidations, localePrefix) {
        const errors = [];
        forOwn(fieldValidations, (isValid, key) => {
            if (!isValid) {
                errors.push({
                    code: `error.${key}`,
                    message: LocaleService.t(`${localePrefix}.${toUpper(snakeCase(key))}`),
                });
            }
        });

        return errors;
    }
}

export default new ErrorService();
